
<!--
 * @Description:布置作业
 * @Author: 王丽欣
 * @Date: 2023-03-01 17:32:04
 * @LastEditors: PF
 * @LastEditTime: 2024-07-22 16:21:47
-->
<template>
  <div class="tan-chuang">
    <el-dialog class="w900 h600" :model-value="openBuZhiZuoYe" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">布置作业详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openBuZhiZuoYe', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :rules="rules" :model="ruleForm" label-width="110px" status-icon>
        <el-row>
          <el-col :span="12">
            <el-form-item label="学期:">
              <span>{{ruleForm.xqmc}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程:">
              {{ruleForm.kcmc}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="周次:">
              <span>第{{ruleForm.zc}}周</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="班级/节次:" class="bjjc">
              <el-row>
                <el-col :span="12">
                  <div style="width:300px">
                    <span>{{ruleForm.bjmc}}/星期{{week[ruleForm.xq]}}第{{ruleForm.jc}}节</span>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教学单元">
              <el-select class="mr10" v-model="ruleForm.jxdyid" @change="danDuanChange" style="width: calc(100% - 70px);">
                <el-option v-for="item in jxdyData" :key="item.id" :label="item.jxdybt" :value="item.id" />
              </el-select>
              <el-button type="primary" @click="openAddJiaoXueDanYuan=true;row={kcid:ruleForm.kcid,kcmc:ruleForm.kcmc}">添加</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教学内容">
              <el-select class="mr10" v-model="ruleForm.jxnrid" style="width: calc(100% - 70px);">
                <el-option v-for="item in jxnrData" :key="item.id" :label="item.jxnrbt" :value="item.id" />
              </el-select>
              <el-button type="primary" @click="openAddJiaoXueNeiRong=true;row={kcid:ruleForm.kcid,kcmc:ruleForm.kcmc,jxdyid:ruleForm.jxdyid}">添加</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="作业"  :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <!-- 作业单选 BEGIN -->
              <div class="an-niu wp100" style="display: flex; align-items: center;">
                <el-button type="primary" class="w100" @click="openZuoYeDanTiao=true">选择</el-button>
                <el-button class="ml10 mr10" link v-if="ruleForm.zymc" @click="ruleForm.zymc='';ruleForm.zyid=''">清空</el-button>
                <el-tag v-if="ruleForm.zymc" :disable-transitions="false">
                  {{ ruleForm.zymc }}
                </el-tag>
              </div>
              <!-- 作业单选 END -->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="截止时间" prop="jzsj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="ruleForm.jzsj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="计入平时成绩" prop="sfjrpscj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-radio-group v-model="ruleForm.sfjrpscj">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span>
          <el-button type="primary" @click="submit()">保存 </el-button>
          <el-button @click="handleClose">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
  <jiaoxuedanyuan v-if="openAddJiaoXueDanYuan" v-model:openAdd="openAddJiaoXueDanYuan" :row="row" @ReturnData="keChengChange" />
  <jiaoxueneirong v-if="openAddJiaoXueNeiRong" v-model:openAdd="openAddJiaoXueNeiRong" :row="row" @ReturnData="danDuanChange" />
  <zuoyedantiao v-if="openZuoYeDanTiao" v-model:openDanTiao="openZuoYeDanTiao" :row="row" @ReturnData="zuoYeReturnData" />
</template>
<script setup>
import { ref, watch, defineProps, defineEmits, unref } from 'vue'
import {
  closeWindow,
  loadSelect,
  actionPost,
  loadData
} from '@/api/common.js'
import jiaoxuedanyuan from '@/components/jiaoxuedanyuan.vue'
import jiaoxueneirong from '@/components/jiaoxueneirong.vue'
import zuoyedantiao from '@/components/home/changguishiwu/jiaoshi/jiaoxuesheji/zuoyedantiao.vue'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'

const props = defineProps({
  openBuZhiZuoYe: {
    type: Boolean,
    required: true
  },
  zuoyeobj: {
    type: Object,
    required: false
  },
  row: {
    type: Object,
    required: false
  },
  chechboxtrue: {
    type: Array,
    required: false
  }
})
const emits = defineEmits(['update:openBuZhiZuoYe', 'ReturnData'])
const week = ref(['', '一', '二', '三', '四', '五', '六', '日'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const jxnrData = ref([])
const jxdyData = ref([])
const openAddJiaoXueDanYuan = ref() // 添加教学单元
const openAddJiaoXueNeiRong = ref() // 添加教学内容
const row = ref()

// 查询教学单元
const keChengChange = (val) => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/list',
    data: jxdyData,
    parms: { kcid: val, order: 'sx', sort: 'asc' }
    // parms: { order: 'sx', sort: 'asc' }
  })
  ruleForm.value.zyid = null
  ruleForm.value.zymc = null
  ruleForm.value.jxnrid = null
  // ruleForm.value.kcid = props.row
}

// const XiaoLiBanJiKeBiaoJiaoXueNeirongChange = (val) => {
//   const o = {
//     url: '/api/v2/jiaowu/jiaowuxiaolibanjikebiaojiaoxueneirong/jiaoxue/' + val,
//     data: {}
//   }
//   actionPost(o).then((res) => {
//     ruleForm.value.jxdyid = res.data ? res.data.jxdyid : null
//     ruleForm.value.jxnrid = res.data ? res.data.jxnrid : null
//     if (ruleForm.value.jxdyid) {
//       danDuanChange()
//     }
//   })
// }
// 查询教学内容
const danDuanChange = () => {
  ruleForm.value.zyid = null
  ruleForm.value.zymc = null
  const o = {
    url: '/api/v2/ziyuanku/kechengjiaoxueneirong/list',
    data: { jxdyid: ruleForm.value.jxdyid, order: 'sx', sort: 'asc' }
  }
  actionPost(o).then((res) => {
    jxnrData.value = res.data
  })
}
danDuanChange()
// 作业单选 BEGIN
const openZuoYeDanTiao = ref(false)
const zuoYeReturnData = (data) => {
  ruleForm.value.zyid = data.id
  ruleForm.value.zymc = data.kcmc
}
// 作业单选 END

// 保存
const submit = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  const options = {
    url: '/api/v2/ziyuanku/xueshengzuoye/buzhi',
    data: {
      jskbid: ruleForm.value.id,
      xqid: ruleForm.value.xqid,
      zc: ruleForm.value.zc,
      xq: ruleForm.value.xq,
      jc: ruleForm.value.jc,
      jzsj: ruleForm.value.jzsj,
      sfjrpscj: ruleForm.value.sfjrpscj,
      zyid: ruleForm.value.zyid,
      jxdyid: ruleForm.value.jxdyid,
      jxnrid: ruleForm.value.jxnrid
    }
  }

  actionPost(options).then((res) => {
    if (res.code === 200) {
      emits('ReturnData')

      handleClose()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 关闭
const handleClose = () => {
  emits('update:openBuZhiZuoYe', false)
}

watch(
  () => props.openBuZhiZuoYe,
  () => {
    if (props.openBuZhiZuoYe) {
      row.value = props.row
      loadData({
        url:
          '/api/v2/jiaowu/jiaowujiaoxuesheji/jiaoshijiaoxueshejikejian/' +
          props.row.id,
        ruleForm,
        loadSuccess: function (res) {
          ruleForm.value.kcmc = res.data.kcmc
          ruleForm.value.zc = res.data.zc
          ruleForm.value.bjmc = res.data.bjmc
          ruleForm.value.xqmc = res.data.xqmc
          ruleForm.value = res.data
          ruleForm.value.kcid = res.data.kcid
          keChengChange(res.data.kcid)
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
